import React from 'react';
import Icon from '../AppIcon';
import { cn } from '../../utils/cn';

const RewardBadge = ({ 
  reward = null,
  size = 'default',
  showLabel = true,
  className = ''
}) => {
  if (!reward) return null;

  const sizeClasses = {
    sm: 'text-xs px-2 py-1',
    default: 'text-sm px-3 py-1.5',
    lg: 'text-base px-4 py-2'
  };

  const iconSizes = {
    sm: 12,
    default: 14,
    lg: 16
  };

  const rewardConfig = {
    trophy: { icon: 'trophy', color: '#F59E0B', bg: '#FEF3C7', label: 'Trophy' },
    medal: { icon: 'award', color: '#EF4444', bg: '#FEE2E2', label: 'Medal' },
    badge: { icon: 'shield', color: '#3B82F6', bg: '#DBEAFE', label: 'Badge' },
    star: { icon: 'star', color: '#F59E0B', bg: '#FEF3C7', label: 'Star' },
    crown: { icon: 'crown', color: '#A855F7', bg: '#F3E8FF', label: 'Crown' },
    gem: { icon: 'gem', color: '#10B981', bg: '#D1FAE5', label: 'Gem' }
  };

  const config = rewardConfig?.[reward] || rewardConfig?.star;

  return (
    <div
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full font-medium transition-smooth',
        sizeClasses?.[size],
        className
      )}
      style={{
        backgroundColor: config?.bg,
        color: config?.color
      }}
    >
      <Icon name={config?.icon} size={iconSizes?.[size]} color={config?.color} />
      {showLabel && <span>{config?.label}</span>}
    </div>
  );
};

export default RewardBadge;